import CharacterModel from "./CharacterModel";

export default class CharacterLibrary {
    constructor() {
        /** @type {CharacterModel[]} */
        this._characters = [];
    }

    get characters() {
        return this._characters;
    }

    /**
     * 
     * @param {CharacterModel[]} characters 
     */
    registerCharacters(characters) {
        this._characters.push(...characters);
    }

    getCharacterById(characterId) {
        return this._characters.find(character => character.id === characterId);
    }
}